<script setup lang="ts">
  defineProps({
    items: Array,
  });
</script>
<template>
  <section>
    <div class="about-number-block section-wrapper">
      <div class="about-number-block__item" v-for="item in items">
        <div class="about-number-block__number">
          {{ item.number }}
        </div>
        <div class="about-number-block__content">
          <MediaPicture :photo="item.photos" type="icon" class="about-number-block__icon" />
          <span class="about-number-block__text" v-html="item.header"></span>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
  .about-number-block {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 2rem 3rem;
    max-width: 1400px;
    margin: 0 auto;
    width: 98%;

    &__item {
      display: flex;
      flex-direction: column;
      font-weight: var(--font-weight-700);
    }

    &__number {
      font-size: 4rem;
    }

    &__content {
      display: flex;
      align-items: flex-start;
      gap: 0.5rem;

      :deep(.about-number-block__icon) {
        height: 40px;
        aspect-ratio: 1;

        img {
          aspect-ratio: 1;
        }
      }
    }
  }

  @media(max-width: 992px) {
    .about-number-block {
      grid-template-columns: repeat(2, 1fr);
      gap: 2rem;
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }

  @media(max-width: 576px) {
    .about-number-block {
      grid-template-columns: 1fr;
    }
  }
</style>
